import { render, staticRenderFns } from "./plannerPortal.vue?vue&type=template&id=15cbeada&scoped=true"
import script from "./plannerPortal.vue?vue&type=script&lang=js"
export * from "./plannerPortal.vue?vue&type=script&lang=js"
import style0 from "./plannerPortal.vue?vue&type=style&index=0&id=15cbeada&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cbeada",
  null
  
)

export default component.exports